import Vue from 'vue';
import Router from 'vue-router';
import JobQueue from '@/views/JobQueue.vue';
import ReloadHistory from '@/views/ReloadHistory.vue';
import AuditLog from '@/views/AuditLog.vue';
import UpgradeJobs from '@/views/UpgradeJobs.vue';
import ProcessingDashboard from '@/views/ProcessingDashboard.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/', redirect: '/jobqueue' },
    {
      path: '/jobqueue',
      name: 'jobqueue',
      component: JobQueue,
    },
    {
      path: '/reloadhistory',
      name: 'reloadhistory',
      component: ReloadHistory,
    },
    {
      path: '/upgradejobs',
      name: 'upgradejobs',
      component: UpgradeJobs,
    },
    {
      path: '/auditlog',
      name: 'auditlog',
      component: AuditLog,
    },
    {
      path: '/processingdashboard',
      name: 'processingdashboard',
      component: ProcessingDashboard,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
